import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szza006aResponse, SZZA006AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzza006aService {
  /**
  * コンストラクタ
  * @param {SZZA006AService} sZZA006AService
  * @param {ApiCommonService} apiCommonService
  * @memberof UsedSzza006aService
  */
  constructor(
    private sZZA006AService: SZZA006AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * アップロード機能API呼び出し
   * @param {string} fileCategory
   * @param {File} uploadFile
   * @return {*}  {Observable<Szza006aResponse>}
   * @memberof UsedSzza006aService
   */
  upload(fileCategory: string, uploadFile: File): Observable<Szza006aResponse> {
    return this.sZZA006AService.a10WSZZA006APost(fileCategory, uploadFile, 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SYS,
            SgkbConstains.MESSAGE.APINAME_SZZA006A);
          return throwError(err.message);
        })
      );
  }
}
